/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "uanamespace",
    title: "Element Namespace",
    description: "A Universe App Tools element namespace. Validates the namespace format and checks that the element is currently registered in the elements registry.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validFormat: {
            must: true,
            run: function () {
                return validate({ title: "Element" }, "ua.navbar.item");
            }
        },
        validAppNamespace: {
            must: true,
            run: function () {
                return validate({ title: "Element" }, "pages.page");
            }
        },
        invalidType: {
            throw: "fields.uanamespace.invalid",
            run: function () {
                return validate({ title: "Element" }, 123);
            }
        },
        invalidFormat: {
            throw: "fields.uanamespace.patternMismatch",
            run: function () {
                return validate({ title: "Element" }, "1bad.element");
            }
        },
        notRegistered: {
            throw: "fields.uanamespace.notRegistered",
            run: function () {
                return validate({ title: "Element" }, "ua.not.installed");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Element Namespace",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        patternMismatch: {
            title: "Invalid Element Namespace Format",
            description: "An element namespace must be dot-separated segments, each starting with a letter, underscore, or dollar sign.",
            template: "Invalid element namespace: '${value}'. Each segment must start with a letter, underscore, or $, followed by letters, digits, underscores, or $."
        },
        notRegistered: {
            title: "Element Not Registered",
            description: "The specified namespace is not registered as an element in the elements registry.",
            template: "Namespace '${value}' not yet registered as an element. Did you install it?"
        }
    }
});

var namespacePattern = /^[a-z_$][a-z0-9_$]*(\.[a-z_$][a-z0-9_$]*)*$/;

var elementsRegistryCache = undefined;

function getElementsRegistry() {
    if (elementsRegistryCache !== undefined) {
        return elementsRegistryCache;
    }

    var canAttemptLoad = typeof window !== "undefined" || typeof document !== "undefined";
    if (!canAttemptLoad) {
        elementsRegistryCache = false;
        return elementsRegistryCache;
    }

    try {
        elementsRegistryCache = require("../.includes/elements.js");
    } catch (error) {
        // Elements registry is optional here. During server-side rendering,
        // test harnesses, or partial bootstrap states it may not be available.
        elementsRegistryCache = false;
    }

    return elementsRegistryCache;
}

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if (!namespacePattern.test(value)) {
        _.errors.patternMismatch.throw({ value: value });
    }

    // Check that the namespace exists in the elements registry if available
    var elementsRegistry = getElementsRegistry();
    if (elementsRegistry) {
        // Walk the dot-separated path to check if the element exists
        var parts = value.split(".");
        var current = elementsRegistry;
        for (var i = 0; i < parts.length; i++) {
            if (current && typeof current === "object" && parts[i] in current) {
                current = current[parts[i]];
            } else {
                _.errors.notRegistered.throw({ value: value });
            }
        }
        // The final resolved value should be a module (object with namespace)
        if (!current || typeof current !== "object" || !current.namespace) {
            _.errors.notRegistered.throw({ value: value });
        }
    }
}
module.exports.validate = validate;
